export default function extractFontStyle(html: string): string | undefined {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const candidates = [
    doc.body,
    ...doc.querySelectorAll<HTMLElement>(
      '[style*="font-family"], [style*="font-size"], [style*="color"]',
    ),
  ].filter((el): el is HTMLElement => Boolean(el));

  for (const el of candidates) {
    const family = el.style.fontFamily;
    const size = el.style.fontSize;
    const color = el.style.color;

    if (family || size || color) {
      return [
        family && `font-family:${family}`,
        size && `font-size:${size}`,
        color && `color:${color}`,
      ]
        .filter(Boolean)
        .join(';');
    }
  }

  return undefined;
}
